


























































































































import { defineComponent, watchEffect, ref, watch, PropType } from '@nuxtjs/composition-api';
import { cloneDeep } from 'lodash-es';
import { MappedAggregation } from '~/features/facets';
import { useSortBy } from '~/features/sortBy';
import { AggregationOption } from '~/graphql-types.gen';

export default defineComponent({
  name: 'FacetDialog',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array as PropType<MappedAggregation[]>,
      required: true,
    },
    sortBy: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    immediate: {
      type: Boolean,
      default: false,
    },
    categoryOptions: {
      type: Array as PropType<AggregationOption[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { options, selectedOption } = useSortBy();
    /*
     * On Dialog close event handler.
     * @returns {void}
     * emit close event , and emits facets value directly if immediate is true
     */
    function close() {
      if (props.immediate) emit('input', facetsInput.value);

      emit('update:isOpen', false);
    }

    const selectedSortOption = ref('');

    /*
     * @summary: facets internal input state object
     * @description: hold a clone of the passed value of facets object
     * @updated on facets props get changed
     * @type {MappedAggregation[]}
     */
    const facetsInput = ref(cloneDeep(props.value));

    /*
     * prevent window from being scrolled when dialog is open
     */
    watchEffect(() => {
      if (process.server) {
        return;
      }

      window.document.body.classList.toggle('overflow-hidden', props.isOpen);
    });

    /*
     * Handle reset filter/facets options values to default
     */
    function resetFilters() {
      facetsInput.value.forEach((facet: any) => {
        if (facet.type === 'price') {
          facet.value = [...facet.options];
          return;
        }

        facet.value = [];
      });

      selectedOption.value = options[0];

      handleApplyFilters();
    }

    /*
     * Handle apply filters button event
     */
    function handleApplyFilters() {
      emit('input', facetsInput.value);

      emit('sort', selectedOption.value);

      close();
    }

    /*
     * Handle when facet value is updated by user , update the selected facet value with the selected option.
     */
    function updateFacet(selectedValues: Array<AggregationOption> | AggregationOption, facet: MappedAggregation) {
      if (Array.isArray(selectedValues)) {
        facet.value = selectedValues;
        return;
      }

      facet.value = [selectedValues];
    }

    /*
     * emit sortBy value when sortBy option is changed
     */
    watch(selectedOption, value => {
      if (props.immediate) emit('sort', value);
    });

    /*
     * update selected facet values when facets props gets updated
     */
    watch(
      () => props.value,
      value => (facetsInput.value = cloneDeep(value))
    );

    return {
      close,
      selectedSortOption,
      updateFacet,
      resetFilters,
      options,
      selectedOption,
      facetsInput,
      handleApplyFilters,
    };
  },
});
